<!--
 * @Description: 分区管理
 * @Author: xu wei
 * @Date: 2020-03-05 14:15:46
 * @LastEditTime: 2020-08-31 10:26:14
 * @LastEditors: gao shuai
 -->
<template>
  <div class="home">
    <div class="gs_title">分区管理</div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>所属分组：</span>
          <span class="txtbox">
            <el-select v-model="belongTeam" clearable @change="() => { pageIndex = 1; getlist() }" size="small"
              placeholder="请选择">
              <el-option v-for="(item, i) in belongTeamdrow" :key="'gameDivision' + i" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>游戏模板：</span>
          <span class="txtbox">
            <el-select v-model="gameMoudle" clearable @change="() => { pageIndex = 1; getlist() }" size="small"
              placeholder="请选择">
              <el-option v-for="(item, i) in gameMoudledrow" :key="'gameDivision' + i" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tabbox clearfix mgt15">
      <div class="tabbox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="传奇" name="1"></el-tab-pane>
          <el-tab-pane label="传世" name="2"></el-tab-pane>
          <el-tab-pane label="传奇三" name="3"></el-tab-pane>
          <el-tab-pane label="SQL通用" name="4"></el-tab-pane>
          <el-tab-pane label="Web通讯" name="5"></el-tab-pane>         
          <el-tab-pane label="奇迹MU" name="6"></el-tab-pane>         
        </el-tabs>
      </div>
      <div class="btnsbox fr mgt10">
        <el-button size="small" type="primary" :disabled="selectList.length === 0" @click="sortArea">排序</el-button>
        <el-button size="small" type="danger" :disabled="selectList.length === 0"
          @click="handleClose(selectList)">删除</el-button>
      </div>
    </div>
    <div class="tablebox pdb15 pdt20">
      <div class="gs_tablebox padding_change">
        <el-table ref="moduleTable" size="mini" @selection-change="selchange" :data="tableData" border style="width: 100%"
          stripe>
          <el-table-column type="selection" width="42">
          </el-table-column>
          <el-table-column prop="date" label="排序" width="60">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.sort" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="编号" width="60">
          </el-table-column>
          <el-table-column prop="name" label="名称" width="200">
          </el-table-column>
          <el-table-column prop="currencyName" label="游戏币" width="80">
          </el-table-column>
          <el-table-column prop="serverIp" label="服务器" width="120">
          </el-table-column>
          <el-table-column prop="scriptPath" label="路径">
          </el-table-column>
          <el-table-column prop="name" label="操作" width='450'>
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" type="primary" @click="rechargeTeam(scope.row.uuid)">充值链接</el-button>
                <el-button size="mini" type="primary" @click="checklink(scope.row.id, scope.$index)"
                  :loading="!checkflag && checkIndex === scope.$index">检测</el-button>
                <el-button size="mini" type="primary" @click="editarea(scope.row.id)">编辑</el-button>
                <el-button size="mini" type="primary" @click="showdialog(scope.row.id)">加载</el-button>
                <el-button size="mini" type="primary" @click="areaClone(scope.row.id)">克隆</el-button>
                <el-button size="mini" type="primary" @click="toOrderreissue(scope.row.id)">补发</el-button>
                <el-button size="mini" type="danger" @click.prevent="handleClose([{ id: scope.row.id }])">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mgt15 pdl20">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :page-sizes="[10, 20, 30, 40]" :current-page="pageIndex" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 登录密码的修改弹框 -->
    <el-dialog title="加载分区" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="400px">
      <p class="mgb10 mgt10">
        <el-checkbox v-model="dialog.checked" :true-label="2" :false-label="1">全部更新</el-checkbox>
      </p>
      <p class="tc pdb10">
        <el-button size="small" type="primary" @click="loadingArea">确定</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '0', // tab
      checkflag: true, // 检测的flag
      checkIndex: '', // 检测的Index
      belongTeam: '', // 所属分组
      gameMoudle: '', // 游戏模板
      selectList: [], // 多选变化
      belongTeamdrow: [], // 所属分组下拉
      gameMoudledrow: [], // 游戏模板下拉
      pageIndex: 1, // 页码
      pageSize: 20, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialog: {
        show: false,
        checked: 1,
        id: ''
      },
      timer: null // 检测时的定时器
    };
  },
  methods: {
    // tab的切换
    handleClick() {
      this.pageIndex = 1;
      this.pageSize = 20;
      this.total = 0;
      this.tableData = [];
      this.getlist();
    },
    // 获取列表
    getlist() {
      this.$api.groupmange
        .arealist({
          Type: this.activeName,
          GroupNameID: this.belongTeam === '' ? 0 : this.belongTeam,
          TemplatesID: this.gameMoudle === '' ? 0 : this.gameMoudle,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 所属分组下拉
    belongDrow() {
      this.$api.groupmange
        .belongDrow()
        .then((data) => {
          if (data.status === 200) {
            this.belongTeamdrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 游戏模板
    gameDrow() {
      this.$api.groupmange
        .gameDrow()
        .then((data) => {
          if (data.status === 200) {
            this.gameMoudledrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 多选发生变化
    selchange(data) {
      this.selectList = data.map((item) => {
        return { id: item.id };
      });
    },
    // 排序
    sortArea() {
      let flag = true;
      let arr1 = this.selectList.map((item) => {
        let sel = this.tableData.filter((li) => {
          return li.id === item.id;
        })[0];
        if (sel.sort === '') {
          flag = false;
        } else {
          return {
            id: item.id,
            sort: sel.sort
          };
        }
      });
      if (flag) {
        this.$api.groupmange
          .sortAreas(arr1)
          .then((data) => {
            if (data.status === 200) {
              this.$messageSuccess('排序成功！');
              this.getlist();
            }
          })
          .catch((err) => {
            this.$messageError(err.message);
          });
      } else {
        this.$messageError('排序不能为空！');
      }
    },
    // 多行删除
    sigleDelarea(selc) {
      this.$api.groupmange
        .delAreas(selc)
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(selc) {
      this.$confirm('删除分区将导致充值无法完成!')
        .then(() => {
          this.sigleDelarea(selc);
        })
        .catch((_) => { });
    },
    // 充值
    rechargeTeam(uuid) {
      var url = "";
      this.$api.groupmange
        .rechargeteam({
          typeId: 0
        })
        .then((data) => {
          if (data.status === 200) {
            url = data.data + '/recharge/' + uuid;
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand('Copy'); // 执行浏览器复制命令
            oInput.className = 'oInput';
            oInput.style.display = 'none';
            this.$messageSuccess('复制成功');
            document.body.removeChild(oInput);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑分区
    editarea(id) {
      this.$router.push({ path: '/main/partinstallEdit', query: { id: id } });
    },
    // 加载
    showdialog(id) {
      this.dialog.id = id;
      this.dialog.show = true;
    },
    // 加载分区
    loadingArea() {
      this.$api.groupmange
        .loadingArea({
          id: this.dialog.id,
          partitionCmdType: this.dialog.checked
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('加载成功！');
            this.dialog.show = false;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框初始化
    dialoginit() {
      this.dialog.checked = 0;
      this.dialog.id = '';
    },
    // clone分区
    areaClone(id) {
      this.$router.push({ path: '/main/partinstallClone', query: { id: id } });
    },
    // 补发订单
    toOrderreissue(id) {
      this.$router.push({ path: '/main/Orderreissue', query: { id: id } });
    },
    // 分区检测
    checklink(id, index) {
      if (this.checkflag) {
        this.checkflag = false;
        this.checkIndex = index;
        this.$api.groupmange
          .checkLink({
            partitionId: id
          })
          .then((data) => {
            if (data.status === 200) {
              let keyValue = data.data;
              let indexNum = 0;
              // this.$messageSuccess('检测成功！');
              this.timer = setInterval(() => {
                this.$api.groupmange
                  .timerCheck({
                    checkKey: keyValue
                  })
                  .then((data) => {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.checkflag = true;
                    this.checkIndex = '';
                    this.$messageSuccess('检测成功！');
                  })
                  .catch(() => {
                    indexNum++;
                    if (indexNum > 6) {
                      clearInterval(this.timer);
                      this.timer = null;
                      this.checkflag = true;
                      this.checkIndex = '';
                      this.$messageError('检测失败！');
                    }
                  });
              }, 3000);
            }
          })
          .catch(() => {
            this.checkflag = true;
            this.checkIndex = '';
            this.$messageError('检测失败！');
          });
      }
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
    this.belongDrow();
    this.gameDrow();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;

  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      .tit {
        font-size: 14px;
        color: #87566a;
        margin-right: 5px;
      }

      .txtbox {
        display: inline-block;
      }
    }
  }
}

.tablebox {
  background: #fff;
}

.padding_change {
  &::v-deep .el-table {
    .cell {
      padding-left: 5px;
      padding-right: 5px;

    }
  }
}</style>
